import React, { useState, useEffect, useRef } from "react";
import Classes from "../Profile.module.css";

export default function Extras({ data, update, onBack, onFinish }) {
  const fileInputRef = useRef(null);
  const [form, setForm] = useState(data);
  const [dragging, setDragging] = useState(false);

  useEffect(() => setForm(data), [data]);

  const textChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    update({ [name]: value });
  };

  const addFiles = (list) => {
    const newFiles = [...(form?.files || []), ...list];
    setForm((p) => ({ ...p, files: newFiles }));
    update({ files: newFiles });
  };

  const handleDrop = (e) => { e.preventDefault(); setDragging(false); addFiles(Array.from(e.dataTransfer.files)); };
  const handleSubmit = (e) => { e.preventDefault(); onFinish(); };

  return (
    <form className={Classes.infoCon} onSubmit={handleSubmit}>
      <div className={Classes.infoConMiddle}>
        {[
          ["linkedinUrl", "LinkedIn Profile URL", "https://www.linkedin.com/in/yourname"],
          ["portfolioUrl", "Portfolio URL", "https://portfolio.example.com"],
        ].map(([name, label, placeholder]) => (
          <div className={Classes.flexColGroup} key={name}>
            <div className={Classes.flexCol1}>
              <div className="flexAlign10">
                <h5 className={Classes.label}>{label}</h5>
                <div className="optionalText"><h5>Optional</h5></div>
              </div>
              <input
                name={name}
                className={Classes.inputField}
                placeholder={placeholder}
                value={form[name] ?? ""}
                onChange={textChange}
              />
            </div>
          </div>
        ))}

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className="flexAlign10">
              <h5 className={Classes.label}>Resume</h5>
              <div className="optionalText"><h5>Optional</h5></div>
            </div>
            <div
              className={`${Classes.fileUpload} ${dragging ? Classes.dragActive : ""}`}
              onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
              onDragLeave={() => setDragging(false)}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
            >
              <input
                ref={fileInputRef}
                type="file"
                multiple
                className={Classes.fileInput}
                onChange={(e) => addFiles(Array.from(e.target.files || []))}
              />
              <h5><span className={Classes.browseText}>Browse</span> or drag and drop</h5>
            </div>

            {form?.files?.length > 0 && (
              <ul className={Classes.fileList}>
                {form.files.map((f, i) => (<li key={i}><h5>{f?.name}</h5></li>))}
              </ul>
            )}
          </div>
        </div>
      </div>

      <button type="submit" className={Classes.saveBtn}><h5>Finish</h5></button>
    </form>
  );
}
